export default __webpack_public_path__ + "static/media/logo_pay-trace.4cbd6be0.svg";